import React, { useState, useEffect, useMemo, useRef } from 'react';
import { Link } from 'react-router-dom';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { Listing } from '../types';
import useListings from '../hooks/useListings';
import Loading from '../components/Loading';

// Custom SVG marker with brand colors and emblem
const createMarkerSvg = (pinColor: string, emblemColor: string) => `
  <svg width="32" height="48" viewBox="0 0 32 48" xmlns="http://www.w3.org/2000/svg">
    <path d="M16 0C7.2 0 0 7.2 0 16c0 3.1.9 5.9 2.4 8.3L16 48l13.6-23.7c1.5-2.4 2.4-5.2 2.4-8.3C32 7.2 24.8 0 16 0z" fill="${pinColor}"/>
    <g transform="translate(6, 6) scale(0.25)">
      <path fill="${emblemColor}" d="M77.9454,35.7667h-2.9897c-.5524,0-1.0081-.4127-1.0828-.96-.1895-1.3861-.4623-2.7454-.8107-4.0744-.14-.5342.1243-1.0873.6345-1.2987l2.7615-1.1439c.5616-.2326.8283-.8765.5957-1.4381l-2.0325-4.9069c-.2327-.5616-.8765-.8284-1.4382-.5957l-2.7593,1.1429c-.5096.2111-1.0873.006-1.3664-.4697-.7031-1.1985-1.4771-2.3499-2.3145-3.4509-.3346-.4399-.3029-1.0533.088-1.4441l2.1169-2.1169c.4298-.4299.4298-1.1268,0-1.5566l-3.7556-3.7556c-.4299-.4299-1.1268-.4299-1.5566,0l-2.1169,2.1169c-.3908.3908-1.0043.4225-1.4442.088-1.1009-.8374-2.2524-1.6115-3.4508-2.3145-.4758-.2791-.6808-.8568-.4697-1.3663l1.1429-2.7593c.2326-.5616-.0341-1.2056-.5958-1.4382l-4.9069-2.0325c-.5616-.2326-1.2054.0341-1.438.5957l-1.1439,2.7616c-.2113.5102-.7645.7745-1.2987.6345-1.3289-.3484-2.6882-.6212-4.0744-.8107-.5473-.0748-.9599-.5305-.9599-1.0829V1.1006c0-.6079-.4928-1.1006-1.1006-1.1006h-5.3113c-.6079,0-1.1006.4927-1.1006,1.1006v2.9897c0,.5524-.4126,1.0081-.9599,1.0829-1.3862.1895-2.7454.4623-4.0744.8107-.5342.14-1.0873-.1243-1.2987-.6345l-1.1439-2.7615c-.2326-.5616-.8765-.8284-1.4381-.5957l-4.907,2.0325c-.5616.2326-.8284.8765-.5957,1.4381l1.1429,2.7594c.2111.5096.0061,1.0873-.4697,1.3664-1.1984.7031-2.3499,1.4771-3.4508,2.3145-.4399.3346-1.0533.3029-1.4441-.088l-2.1169-2.1169c-.4299-.4299-1.1268-.4299-1.5566,0l-3.7556,3.7556c-.4299.4298-.4299,1.1268,0,1.5566l2.1169,2.1169c.3908.3908.4225,1.0042.088,1.4441-.8374,1.101-1.6115,2.2524-2.3145,3.4509-.2791.4757-.8568.6807-1.3663.4697l-2.7593-1.1429c-.5616-.2327-1.2056.0341-1.4382.5957l-2.0325,4.9069c-.2327.5616.0341,1.2055.5957,1.4382l2.7616,1.1439c.5102.2114.7745.7645.6345,1.2987-.3484,1.329-.6212,2.6883-.8107,4.0744-.0748.5473-.5305.96-1.0829.96H1.1007c-.6079,0-1.1007.4928-1.1007,1.1007v5.3112c0,.6079.4928,1.1007,1.1007,1.1007h2.9897c.5524,0,1.0081.4126,1.0829.9599.1895,1.3861.4623,2.7454.8107,4.0743.14.5342-.1243,1.0874-.6345,1.2987l-2.7617,1.1439c-.5616.2326-.8283.8765-.5956,1.4381l2.0325,4.907c.2326.5616.8765.8283,1.4382.5957l2.7593-1.143c.5096-.2111,1.0873-.0061,1.3664.4697.7031,1.1984,1.4771,2.3499,2.3145,3.4508.3346.4399.3029,1.0533-.088,1.4441l-2.1169,2.117c-.4299.4298-.4299,1.1268,0,1.5566l3.7556,3.7556c.4298.4298,1.1268.4298,1.5566,0l2.1169-2.117c.3908-.3907,1.0042-.4225,1.4441-.0879,1.1009.8373,2.2524,1.6114,3.4508,2.3144.4758.2791.6808.8568.4697,1.3664l-1.1429,2.7594c-.2327.5616.0341,1.2055.5957,1.4382l4.907,2.0325c.5616.2326,1.2054-.0341,1.4381-.5957l1.1439-2.7617c.2114-.5102.7645-.7745,1.2987-.6344,1.329.3483,2.6882.6212,4.0744.8106.5473.0748.9599.5305.9599,1.0829v2.9898c0,.6079.4928,1.1007,1.1007,1.1007h5.3112c.6079,0,1.1007-.4928,1.1007-1.1007v-2.9898c0-.5524.4126-1.0081.9599-1.0828,1.3862-.1895,2.7455-.4623,4.0744-.8107.5342-.1401,1.0874.1242,1.2987.6345l1.1439,2.7616c.2326.5616.8765.8283,1.4381.5956l4.9069-2.0325c.5616-.2327.8283-.8765.5957-1.4382l-1.1429-2.7593c-.2111-.5096-.0061-1.0873.4697-1.3664,1.1984-.7031,2.3499-1.4771,3.4508-2.3145.4399-.3346,1.0533-.3029,1.4442.088l2.1169,2.1169c.4298.4298,1.1268.4298,1.5566,0l3.7556-3.7556c.4298-.4299.4298-1.1268,0-1.5566l-2.1169-2.117c-.3908-.3907-.4225-1.0042-.088-1.4441.8373-1.1009,1.6114-2.2524,2.3144-3.4508.2791-.4758.8568-.6807,1.3664-.4697l2.7594,1.143c.5616.2326,1.2055-.0341,1.4382-.5958l2.0325-4.9069c.2326-.5616-.0341-1.2055-.5957-1.4382l-2.7615-1.1439c-.5103-.2113-.7745-.7645-.6345-1.2987.3483-1.3289.6212-2.6882.8106-4.0743.0748-.5473.5305-.9599,1.0829-.9599h2.9897c.6079,0,1.1007-.4928,1.1007-1.1007v-5.3112c0-.6079-.4928-1.1007-1.1007-1.1007ZM39.523,13.8033c6.6337,0,12.6797,2.5126,17.2413,6.6365l-4.7548,4.7548c-.1382-.1205-.2655-.253-.4072-.3696l.0018-.0031,1.0949-3.1572c.1467-.4493-.0413-.94-.4507-1.1763l-2.6037-1.5032c-.4093-.2363-.9282-.1537-1.244.1979l-2.1868,2.5269-.0101.0174c-1.1423-.4291-2.3342-.7499-3.5688-.9536v-.0228l-.6304-3.2817c-.0977-.4625-.5057-.7934-.9784-.7934h-3.0065c-.4727,0-.8808.3309-.9785.7934l-.6304,3.2816v.0229c-1.2346.2036-2.4265.5244-3.5688.9536l-.0101-.0174-2.1868-2.5269c-.3158-.3517-.8347-.4343-1.244-.1979l-2.6037,1.5032c-.4093.2363-.5973.7271-.4506,1.1763l1.0948,3.1572.0018.0032c-.1437.1182-.2729.2525-.4131.3748l-4.7549-4.7549c4.5623-4.1271,10.6108-6.6417,17.2473-6.6417ZM48.8967,32.4734c.1595-.0491.3286-.0087.4658.0892.4266.6019.7963,1.2446,1.1083,1.9211.0155.1671-.0339.3331-.1558.4463l-1.2689,1.1324c.1984.5457.3525,1.1113.4553,1.6962l1.6642.3461c.166.038.2946.1611.3633.3188.0328.3626.0555.7283.0555,1.0995s-.0226.7369-.0555,1.0995c-.0687.1578-.1974.2809-.3633.3188l-1.6642.3461c-.1028.5849-.2569,1.1504-.4553,1.6962l1.2689,1.1324c.1091.1013.1518.2462.1502.3951-.314.6908-.668,1.359-1.1027,1.9724-.1371.0978-.3062.1383-.4658.0892l-.7361-.2428-4.73-4.73c.3318-.6225.5375-1.3222.5375-2.0768s-.2057-1.4544-.5375-2.0769l4.73-4.73.7361-.2427ZM46.5726,48.8967c.0471.1526.0082.3126-.0806.4464-.607.4307-1.2508.8128-1.934,1.1271-.1656.0144-.3298-.0344-.442-.1552l-1.1324-1.2689c-.5458.1984-1.1113.3525-1.6962.4553l-.3461,1.6642c-.038.166-.1611.2946-.3188.3633-.3626.0328-.7283.0555-1.0995.0555s-.7368-.0226-1.0994-.0555c-.1578-.0687-.281-.1974-.319-.3633l-.3461-1.6642c-.5849-.1028-1.1505-.2569-1.6962-.4553l-1.1324,1.2689c-.1055.1136-.2578.1583-.413.1521-.6979-.3198-1.3561-.7076-1.9737-1.148-.0781-.1292-.1143-.2783-.0699-.4224l.2427-.7361,4.73-4.73c.6225.3318,1.3223.5375,2.0769.5375.7516,0,1.4488-.2042,2.0695-.5335l4.7429,4.7429.2372.7193ZM30.1494,46.5726c-.1441.0444-.2932.0081-.4222-.0699-.4405-.6177-.8284-1.2758-1.1482-1.9739-.0062-.1553.0386-.3074.1521-.4128l1.2689-1.1324c-.1984-.5458-.3525-1.1113-.4553-1.6962l-1.6642-.3461c-.1659-.038-.2946-.1611-.3633-.3188-.0328-.3627-.0555-.7283-.0555-1.0995s.0226-.7369.0555-1.0995c.0687-.1577.1974-.2808.3633-.3188l1.6642-.3461c.1028-.5848.2569-1.1505.4553-1.6962l-1.2689-1.1324c-.1158-.1075-.1616-.2634-.1531-.4218.3173-.6917.701-1.3453,1.1366-1.9594.1317-.0836.2863-.1212.4348-.0754l.7193.2372,4.7429,4.7429c-.3293.6207-.5335,1.3179-.5335,2.0696s.2042,1.4487.5335,2.0695l-4.7428,4.7429-.7194.2372ZM32.4734,30.1494c-.0476-.1546-.0083-.317.083-.4518.6036-.43,1.2466-.8084,1.9273-1.1223.1671-.0156.3331.0338.4463.1558l1.1324,1.2689c.5457-.1984,1.1113-.3525,1.6962-.4553l.3461-1.6642c.038-.166.1612-.2947.319-.3634.3626-.0328.7282-.0555,1.0994-.0555s.7369.0226,1.0995.0555c.1578.0687.2809.1974.3188.3634l.3461,1.6642c.5848.1028,1.1504.2569,1.6962.4553l1.1324-1.2689c.1132-.1219.2792-.1713.4463-.1558.6905.3184,1.3302.7195,1.9425,1.1564.076.1282.1118.2753.0678.4177l-.2372.7194-4.7429,4.7428c-.6207-.3293-1.3178-.5335-2.0695-.5335-.7546,0-1.4543.2057-2.0768.5375l-4.7301-4.7301-.2427-.7361ZM20.4398,56.7643c-4.1239-4.5616-6.6365-10.6077-6.6365-17.2413s2.5125-12.6797,6.6364-17.2413l4.7548,4.7548c-.1205.1382-.2529.2655-.3695.4072l-.0031-.0018-3.1572-1.0949c-.4493-.1467-.9399.0413-1.1763.4506l-1.5032,2.6036c-.2363.4094-.1538.9283.1979,1.2441l2.5267,2.1867.0175.0101c-.4291,1.1422-.7499,2.3342-.9536,3.5688h-.0228l-3.2817.6304c-.4625.0977-.7934.5057-.7934.9784v3.0065c0,.4727.3309.8808.7934.9785l3.2816.6304h.0229c.2036,1.2346.5244,2.4266.9536,3.5688l-.0175.0101-2.5268,2.1868c-.3517.3158-.4343.8347-.1979,1.244l1.5032,2.6036c.2363.4094.727.5974,1.1763.4507l3.1572-1.0949.0031-.0018c.1166.1417.249.269.3696.4072l-4.7548,4.7548ZM39.523,65.2427c-6.6365,0-12.685-2.5146-17.2473-6.6416l4.7549-4.7549c.1401.1223.2693.2567.413.3749l-.0018.0031-1.0949,3.1572c-.1467.4493.0413.94.4506,1.1763l2.6037,1.5032c.4094.2363.9283.1538,1.2441-.1979l2.1867-2.5268.0101-.0175c1.1423.4291,2.3343.7499,3.5688.9536v.0229l.6304,3.2816c.0977.4625.5058.7934.9785.7934h3.0065c.4727,0,.8807-.3309.9784-.7934l.6304-3.2817v-.0228c1.2346-.2036,2.4266-.5244,3.5688-.9536l.0101.0175,2.1868,2.5268c.3158.3517.8347.4342,1.244.1979l2.6037-1.5032c.4094-.2363.5973-.727.4506-1.1763l-1.0949-3.1572-.0018-.0031c.1417-.1166.269-.249.4072-.3695l4.7548,4.7548c-4.5616,4.1238-10.6076,6.6364-17.2413,6.6364ZM58.601,56.7703l-4.7549-4.7549c.1224-.1401.2567-.2693.3749-.4131l.0031.0018,3.1572,1.0949c.4493.1467.94-.0413,1.1763-.4507l1.5032-2.6036c.2363-.4094.1538-.9282-.1979-1.244l-2.5269-2.1868-.0174-.0101c.4291-1.1423.7499-2.3342.9536-3.5688h.0229l3.2816-.6304c.4625-.0977.7934-.5058.7934-.9785v-3.0065c0-.4727-.3309-.8807-.7934-.9784l-3.2817-.6304h-.0228c-.2036-1.2346-.5244-2.4266-.9536-3.5688l.0175-.0101,2.5268-2.1867c.3517-.3158.4342-.8347.1979-1.2441l-1.5032-2.6036c-.2363-.4094-.727-.5973-1.1763-.4506l-3.1572,1.0949-.0031.0018c-.1182-.1437-.2526-.2729-.3749-.413l4.7549-4.7549c4.127,4.5623,6.6416,10.6108,6.6416,17.2473s-2.5146,12.6851-6.6417,17.2473Z"/>
    </g>
  </svg>
`;

// Default marker icon (navy pin, gold emblem)
const defaultIcon = L.divIcon({
  html: createMarkerSvg('#002b5c', '#dac792'),
  className: 'custom-marker',
  iconSize: [32, 48],
  iconAnchor: [16, 48],
  popupAnchor: [0, -48]
});

// Highlighted marker icon (gold pin, navy emblem)
const highlightedIcon = L.divIcon({
  html: createMarkerSvg('#dac792', '#002b5c'),
  className: 'custom-marker',
  iconSize: [32, 48],
  iconAnchor: [16, 48],
  popupAnchor: [0, -48]
});

// Default center (Royersford, PA area)
const DEFAULT_CENTER: [number, number] = [40.1855, -75.5395];
const DEFAULT_ZOOM = 10;

// Generate listing URL with idxID and address slug
const getListingUrl = (listing: Listing): string => {
  const addressSlug = listing.address
    .replace(/[^a-zA-Z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .trim();
  return listing.idxID
    ? `/listings/${listing.idxID}/${listing.id}/${addressSlug}`
    : `/listings/${listing.id}`;
};

// Component to fit map bounds to all listings
const MapBoundsController: React.FC<{ listings: Listing[]; sidebarOpen: boolean }> = ({ listings, sidebarOpen }) => {
  const map = useMap();
  const lastListingIds = useRef<string>('');
  const initialFitDone = useRef(false);

  // Handle sidebar toggle - invalidate size and re-fit bounds
  useEffect(() => {
    // Small delay to let CSS transition complete
    const timer = setTimeout(() => {
      map.invalidateSize();

      // Re-fit bounds after sidebar toggle if we have listings
      if (initialFitDone.current) {
        const validListings = listings.filter(l => l.latitude && l.longitude);
        if (validListings.length === 1) {
          const listing = validListings[0];
          map.setView([listing.latitude!, listing.longitude!], 14);
        } else if (validListings.length > 1) {
          const bounds = L.latLngBounds(
            validListings.map(l => [l.latitude!, l.longitude!] as [number, number])
          );
          map.fitBounds(bounds, { padding: [50, 50], maxZoom: 15 });
        }
      }
    }, 450);

    return () => clearTimeout(timer);
  }, [sidebarOpen, map, listings]);

  // Initial fit bounds when listings load
  useEffect(() => {
    const validListings = listings.filter(l => l.latitude && l.longitude);
    if (validListings.length === 0) return;

    // Create a key from listing IDs to detect changes
    const listingIds = validListings.map(l => l.id).sort().join(',');
    if (listingIds === lastListingIds.current) return;
    lastListingIds.current = listingIds;

    if (validListings.length === 1) {
      // For single listing, center on it with a reasonable zoom
      const listing = validListings[0];
      map.setView([listing.latitude!, listing.longitude!], 14);
    } else {
      // For multiple listings, fit bounds
      const bounds = L.latLngBounds(
        validListings.map(l => [l.latitude!, l.longitude!] as [number, number])
      );
      map.fitBounds(bounds, { padding: [50, 50], maxZoom: 15 });
    }

    initialFitDone.current = true;
  }, [listings, map]);

  return null;
};

const Search: React.FC = () => {
  const { listings, isLoading } = useListings({ type: 'active' });

  // Filter state
  const [minPrice, setMinPrice] = useState<string>('');
  const [maxPrice, setMaxPrice] = useState<string>('');
  const [minBeds, setMinBeds] = useState<string>('');
  const [minBaths, setMinBaths] = useState<string>('');
  const [mapType, setMapType] = useState<'map' | 'satellite'>('map');
  const [hoveredListingId, setHoveredListingId] = useState<string | null>(null);

  // All listings with valid coordinates (for map bounds)
  const listingsWithCoords = useMemo(() => {
    return listings.filter(l => l.latitude && l.longitude);
  }, [listings]);

  // Filter listings based on criteria (show all listings, not just ones with coordinates)
  const filteredListings = useMemo(() => {
    return listings.filter(listing => {
      // Price filter
      if (minPrice && listing.price < parseInt(minPrice)) return false;
      if (maxPrice && listing.price > parseInt(maxPrice)) return false;

      // Beds filter
      if (minBeds && listing.beds < parseInt(minBeds)) return false;

      // Baths filter
      if (minBaths && listing.baths < parseFloat(minBaths)) return false;

      return true;
    });
  }, [listings, minPrice, maxPrice, minBeds, minBaths]);

  // Filtered listings that have coordinates (for map markers)
  const filteredListingsWithCoords = useMemo(() => {
    return filteredListings.filter(l => l.latitude && l.longitude);
  }, [filteredListings]);

  // Calculate map center based on ALL listings (not filtered)
  const mapCenter = useMemo(() => {
    if (listingsWithCoords.length === 0) return DEFAULT_CENTER;

    const avgLat = listingsWithCoords.reduce((sum, l) => sum + l.latitude!, 0) / listingsWithCoords.length;
    const avgLng = listingsWithCoords.reduce((sum, l) => sum + l.longitude!, 0) / listingsWithCoords.length;

    return [avgLat, avgLng] as [number, number];
  }, [listingsWithCoords]);

  const formatPrice = (price: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0
    }).format(price);
  };

  const clearFilters = () => {
    setMinPrice('');
    setMaxPrice('');
    setMinBeds('');
    setMinBaths('');
  };

  return (
    <>
      <title>Property Search | Kline Real Estate Works</title>
      <meta
        name="description"
        content="Search available properties on the map. Find your next home in Royersford, PA and surrounding areas."
      />
      <meta property="og:title" content="Property Search | Kline Real Estate Works" />
      <meta property="og:description" content="Search available properties on the map. Find your next home in Royersford, PA and surrounding areas." />
      <meta property="og:image" content="https://keithklinegroup.com/og-image.jpg" />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:image" content="https://keithklinegroup.com/og-image.jpg" />

      <div className="search-page">
        {/* Filter Bar */}
        <div className="search-filters">
          <div className="container">
            <div className="filters-row">
              <div className="filter-group">
                <label>Min Price</label>
                <select value={minPrice} onChange={(e) => setMinPrice(e.target.value)}>
                  <option value="">Any</option>
                  <option value="100000">$100,000</option>
                  <option value="200000">$200,000</option>
                  <option value="300000">$300,000</option>
                  <option value="400000">$400,000</option>
                  <option value="500000">$500,000</option>
                  <option value="750000">$750,000</option>
                  <option value="1000000">$1,000,000</option>
                </select>
              </div>

              <div className="filter-group">
                <label>Max Price</label>
                <select value={maxPrice} onChange={(e) => setMaxPrice(e.target.value)}>
                  <option value="">Any</option>
                  <option value="200000">$200,000</option>
                  <option value="300000">$300,000</option>
                  <option value="400000">$400,000</option>
                  <option value="500000">$500,000</option>
                  <option value="750000">$750,000</option>
                  <option value="1000000">$1,000,000</option>
                  <option value="1500000">$1,500,000</option>
                  <option value="2000000">$2,000,000+</option>
                </select>
              </div>

              <div className="filter-group">
                <label>Beds</label>
                <select value={minBeds} onChange={(e) => setMinBeds(e.target.value)}>
                  <option value="">Any</option>
                  <option value="1">1+</option>
                  <option value="2">2+</option>
                  <option value="3">3+</option>
                  <option value="4">4+</option>
                  <option value="5">5+</option>
                </select>
              </div>

              <div className="filter-group">
                <label>Baths</label>
                <select value={minBaths} onChange={(e) => setMinBaths(e.target.value)}>
                  <option value="">Any</option>
                  <option value="1">1+</option>
                  <option value="1.5">1.5+</option>
                  <option value="2">2+</option>
                  <option value="2.5">2.5+</option>
                  <option value="3">3+</option>
                </select>
              </div>

              <button className="btn btn-secondary btn-sm" onClick={clearFilters}>
                Clear Filters
              </button>
            </div>
          </div>
        </div>

        {/* Map and Listings Container */}
        <div className={`search-content ${!isLoading ? 'sidebar-open' : ''}`}>
          {/* Properties Found Pill - floating overlay */}
          {!isLoading && (
            <div className="filter-results">
              {filteredListings.length} {filteredListings.length === 1 ? 'property' : 'properties'} found
            </div>
          )}

          {/* Map */}
          <div className="search-map">
            {isLoading ? (
              <div className="search-map-loading">
                <Loading message="Loading properties..." />
              </div>
            ) : (
              <>
                <div className="map-type-toggle search-map-toggle">
                  <button
                    className={`map-type-btn ${mapType === 'map' ? 'active' : ''}`}
                    onClick={() => setMapType('map')}
                  >
                    Street
                  </button>
                  <button
                    className={`map-type-btn ${mapType === 'satellite' ? 'active' : ''}`}
                    onClick={() => setMapType('satellite')}
                  >
                    Satellite
                  </button>
                </div>
                <MapContainer
                  center={mapCenter}
                  zoom={DEFAULT_ZOOM}
                  scrollWheelZoom={true}
                  style={{ height: '100%', width: '100%' }}
                >
                  <MapBoundsController listings={listingsWithCoords} sidebarOpen={!isLoading} />
                  <TileLayer
                    key={mapType}
                    attribution={mapType === 'map'
                      ? '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                      : 'Tiles &copy; Esri'
                    }
                    url={mapType === 'map'
                      ? 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
                      : 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'
                    }
                  />
                  {filteredListingsWithCoords.map(listing => (
                    <Marker
                      key={listing.id}
                      position={[listing.latitude!, listing.longitude!]}
                      icon={hoveredListingId === listing.id ? highlightedIcon : defaultIcon}
                      zIndexOffset={hoveredListingId === listing.id ? 1000 : 0}
                    >
                      <Popup>
                        <div className="map-popup">
                          <img
                            src={listing.image}
                            alt={listing.address}
                            className="map-popup-image"
                          />
                          <div className="map-popup-content">
                            <div className="map-popup-price">{formatPrice(listing.price)}</div>
                            <div className="map-popup-address">{listing.address}</div>
                            <div className="map-popup-details">
                              {listing.beds} bed &bull; {listing.baths} bath
                              {listing.sqft > 0 && <> &bull; {listing.sqft.toLocaleString()} sqft</>}
                            </div>
                            <Link to={getListingUrl(listing)} className="btn btn-primary btn-sm">
                              View Details
                            </Link>
                          </div>
                        </div>
                      </Popup>
                    </Marker>
                  ))}
                </MapContainer>
              </>
            )}
          </div>

          {/* Listings Sidebar */}
          <div className={`search-listings ${!isLoading ? 'loaded' : ''}`}>
            <h2 className="search-listings-title">Available Properties</h2>
            {!isLoading && (
              filteredListings.length === 0 ? (
                <div className="search-no-results">
                  <span className="material-icons">search_off</span>
                  <p>No properties match your criteria.</p>
                  <button className="btn btn-secondary" onClick={clearFilters}>
                    Clear Filters
                  </button>
                </div>
              ) : (
                <div className="search-listings-list">
                  {filteredListings.map(listing => (
                    <Link
                      key={listing.id}
                      to={getListingUrl(listing)}
                      className={`search-listing-card ${hoveredListingId === listing.id ? 'highlighted' : ''}`}
                      onMouseEnter={() => setHoveredListingId(listing.id)}
                      onMouseLeave={() => setHoveredListingId(null)}
                    >
                      <img
                        src={listing.image}
                        alt={listing.address}
                        className="search-listing-image"
                      />
                      <div className="search-listing-info">
                        <div className="search-listing-price">{formatPrice(listing.price)}</div>
                        <div className="search-listing-address">{listing.address}</div>
                        <div className="search-listing-location">
                          {listing.city}, {listing.state} {listing.zip}
                        </div>
                        <div className="search-listing-details">
                          {listing.beds} bed &bull; {listing.baths} bath
                          {listing.sqft > 0 && <> &bull; {listing.sqft.toLocaleString()} sqft</>}
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              )
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Search;
